import { LitElement, html } from 'lit';

import { api } from '../../api/index.js';
import { customerStateBadge } from '../../components/plane-badge.js';
import { customerLoadState } from '../../components/customer-load-state.js';
import { assistantName, customerStateOf, workspaceName, workspacePath } from '../../i18n/customer-labels.js';
import { poll } from '../../poll.js';
import { customerStyles } from '../../../styles/shared/customer.js';
import { formStyles } from '../../../styles/shared/forms.js';
import { pageStyles } from '../../../styles/shared/page.js';
import { customerHomePageStyles } from '../../../styles/pages/customer/home-page.js';

/**
 * The landing page of a customer user: their workspaces, each with its assistant and its state in
 * a sentence. With a single workspace, its page is the landing page: there is nothing to choose.
 */
class CustomerHomePage extends LitElement {
  static styles = [
    pageStyles,
    formStyles,
    customerStyles,
    customerHomePageStyles,
  ];

  constructor() {
    super();
    this.poll = poll(this, () => api.instances());
  }

  updated() {
    const instances = this.poll.value;
    if (instances?.length === 1) {
      // replaced, not pushed: Back must not bounce here again
      window.history.replaceState({}, '', workspacePath(instances[0].ref));
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  }

  render() {
    const head = html`<header class="page-head"><div><h1>Your workspaces</h1></div></header>`;
    const pending = customerLoadState(this.poll);
    if (pending) {
      return html`${head}${pending}`;
    }
    const instances = this.poll.value;
    if (instances.length === 0) {
      return html`${head}<p class="empty">Your workspace is being set up. It shows here as soon as it is ready.</p>`;
    }
    return html`
      ${head}
      ${instances.map((instance) => {
        const workspace = workspaceName(instance);
        return html`
          <div class="card workspace">
            <div>
              <h2>${workspace} ${customerStateBadge(instance.state)}</h2>
              <p>${instance.assistantNames?.length > 1 ? `Assistants: ${instance.assistantNames.join(', ')}` : `Assistant: ${assistantName(instance)}`}</p>
              <p class="muted">${customerStateOf(instance.state).text(workspace)}</p>
            </div>
            <a class="button primary" href=${workspacePath(instance.ref)}>Open</a>
          </div>
        `;
      })}
    `;
  }
}

customElements.define('plane-customer-home-page', CustomerHomePage);
